export enum StorageService {
    LOCAL = 'LOCAL',
    ONEDRIVE = 'ONEDRIVE',
    SHAREPOINT = 'SHAREPOINT'
}

export interface StorageServiceAdapter {
    available?: () => Promise<boolean>;
    initialize?: () => void;
    activate?: () => Promise<void>;
}

export enum StorageItemType {
    FILE = 'FILE',
    FOLDER = 'FOLDER'
}


export interface StorageServicesOpenRequest {
    services?: StorageService[];
    itemTypes?: StorageItemType[];
    itemNameMasks?: string[]
}

export interface StorageItem {

}

export interface LocalStorageItem extends StorageItem {
    file: File
}

export interface SharepointStorageItem extends StorageItem {
    itemType: StorageItemType;
    driveId: string;
    itemId: string;
    siteId: string;
    webUrl: string;
    name: string;
    userId: string; // TODO by some strange reason it should be set for file uploader step type - remove after backend refactoring
}

export interface SelectedStorageItem {
    service: StorageService;
    item?: StorageItem
}

